import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from "./pages/LandingPage";
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
import ReactGA from 'react-ga4';
import BrowserUpdateNotifier from 'browser-update-notifier';

function App() {
  useEffect(() => {
    ReactGA.initialize('G-X4EWTDNFF3');
    ReactGA.send({ hitType: "pageview", page: 'landing' });

    BrowserUpdateNotifier.init({
      position: 'bottom-left',
      delay: 2000,
      dismissible: true,
      theme: 'light',
      language: 'pt-BR'
    });
  }, []);

  return (
    <>
      <HelmetProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </HelmetProvider>
      <SpeedInsights />
      <Analytics />
    </>
  );
}

export default App;
